import { Helmet } from "react-helmet-async";
import WhyChooseUsSection from "../components/WhyChooseUsSection";

export default function WhyUsPage() {
  return (
    <>
      <Helmet>
        <title>Why Choose Us | Nexalus Infotech</title>
        <meta
          name="description"
          content="Why businesses choose Nexalus Infotech for ELV and ICT — quality, support, expertise, and proven delivery."
        />
      </Helmet>
      <main className="pt-24">
        <WhyChooseUsSection />
      </main>
    </>
  );
}
